import { createSelector } from 'reselect';

const getQuestionsSelector = state => state.funnels.questions.items;
const getAnswersSelector = state => state.funnels.answers.items;

function answersForQuestion(answers, question) {
  return answers
    .filter(a => a.question.toString() === question.id.toString())
    .sortBy(a => a.order)
    .toArray();
}

export const getQuestionsWithAnswers = createSelector(
  getQuestionsSelector,
  getAnswersSelector,
  (questions, answers) => {
    return questions
      .map(q => {
        return {
          ...q,
          answers: answersForQuestion(answers, q),
        };
      })
      .sortBy(q => q.order)
      .toArray();
  }
);



// WEBPACK FOOTER //
// ./src/modules/funnel/selectors/question.js